import { BaseParameterTypes } from '../shared/baseParams';

export const DRILLING_LOADS_MNEMONICS = [
  'A_HKL_PU',
  'A_HKL_PU_R',
  'A_HKL_PU_P',
  'A_HKL_PU_R_P',
  'A_HKL_SO',
  'A_HKL_SO_R',
  'A_HKL_SO_P',
  'A_HKL_SO_R_P',
  'A_HKL_H_R',
  'A_HKL_H_R_P',
  'A_TQ_OFFB',
  'A_TQ_OFFB_P',
  'A_TQ_OB_P',
  'A_SPP_OFFB',
  'A_SPP_OB_RT',
  'A_SPP_OB_SL',
  'A_MFI_OFFB',
  'A_MFI_OB_RT',
  'A_MFI_OB_SL',
] as const;

export const timeParametersSupportCorridorFollowing = [
  BaseParameterTypes.STANDPIPE_PRESSURE,
  BaseParameterTypes.WEIGHT_ON_BIT,
  BaseParameterTypes.ROTARY_TORQUE,
  BaseParameterTypes.MUD_FLOW_IN,
  BaseParameterTypes.MUD_FLOW_OUT,
  BaseParameterTypes.MUD_FLOW_OUT_PERCENT,
  BaseParameterTypes.TOTAL_PUMPS_STROKE_RATE,
  BaseParameterTypes.RATE_OF_PENETRATION,
  BaseParameterTypes.BIT_CONTACT_PRESSURE,
  BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE,
  BaseParameterTypes.MECH_SPEC_ENERGY_BIT,
  BaseParameterTypes.BIT_SPEED,
  BaseParameterTypes.ROTARY_SPEED,
];
